import Block from "@sanity/block-content-to-react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import DiagonalFrosting from "@/components/DiagonalFrosting"
import MovingGradientLite from "@/components/MovingGradientLite"
import SingleInputSignupForm from "@/components/SingleInputSignupForm"
import * as styles from "@/styles/modules/ConversionBlock.module.scss"

const ConversionBlock = ({ data, className }) => {
  const { type, heading, subhead, btnCaption, image } = data

  function renderMedia() {
    const theImage = image.asset ? getImage(image.asset) : null
    switch (type) {
      case "split":
        return <GatsbyImage image={theImage} alt="" className={styles.image} />
      case "movingGradient":
        return (
          <>
            <DiagonalFrosting className={styles.diagonalFrosting} />
            <GatsbyImage image={theImage} alt="" className={styles.image} />
            <MovingGradientLite />
          </>
        )
      default:
        break
    }
  }

  return (
    <div
      className={`${styles.wrapper} ${styles[type]} ${
        className ? className : ""
      }`}
    >
      <div className={styles.messaging}>
        <div className={styles.textContent}>
          <h2 className={styles.heading}>{heading}</h2>
          <Block
            blocks={subhead._rawData}
            renderContainerOnSingleChild
            className="block"
          />
        </div>
        <SingleInputSignupForm formName="Conversion Block Subscribe Form" />
        {btnCaption && (
          <p className={`caption ${styles.btnCaption}`}>{btnCaption}</p>
        )}
      </div>
      {(type === "split" || type === "movingGradient") && (
        <div className={styles.mediaColumn}>{renderMedia()}</div>
      )}
    </div>
  )
}

ConversionBlock.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.oneOf(["basic", "split", "movingGradient"]),
    heading: PropTypes.string.isRequired,
    subhead: PropTypes.shape({
      _rawData: PropTypes.array.isRequired,
    }).isRequired,
    btnText: PropTypes.string.isRequired,
    btnUrl: PropTypes.shape({
      linkType: PropTypes.string.isRequired,
      href: PropTypes.string,
      blank: PropTypes.bool,
      internalLink: PropTypes.string,
    }).isRequired,
    btnCaption: PropTypes.string,
    image: PropTypes.object,
  }).isRequired,
}

export default ConversionBlock
